import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const imageBox = css`
  width: ${rem(120)};
  margin: ${rem(16)} auto;
  & > img {
    width: 100%;
  }
`

const textArea = css`
  max-width: 100%;
`

const agentTypeDescription = css`
  display: block;
  margin: 4px 0px 10px 0;
`

const upgradeButton = css`
  margin-left: 4px;
`
const agentDescriptionLong = css`
  margin-top: 8px;
`

const annualComparison = theme => css`
  margin-top: 16px;
  padding: 16px;
  border-radius: 8px;
  background: ${theme.color.info['50']};
  color: ${theme.color.info['900']};
  overflow-wrap: anywhere;
  p {
    margin: 0 0 8px;
  }
`

const annualLink = theme => css`
  min-width: 44px;
  min-height: 44px;
  max-width: 100%;
  padding: 8px 0;
  border: 0;
  background: transparent;
  color: ${theme.color.info['900']};
  font: inherit;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
  &:focus-visible {
    outline: 2px solid ${theme.color.info['900']};
    outline-offset: 2px;
  }
`

export const styles = {
  annualComparison,
  annualLink,
  imageBox,
  textArea,
  agentTypeDescription,
  upgradeButton,
  agentDescriptionLong,
}
